// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__HPtjE","validationTips":"StatementDescriptor_validationTips__1R47s"};